<main>
    <mat-sidenav-container class="example-container">
        <!-- sidebar menu  -->
        <mat-sidenav #sidebar mode="over">
            <app-sidebar-list></app-sidebar-list>
        </mat-sidenav>

        <mat-sidenav-content class="sidenav-content-container">
            <div class="main-wrapper">
                <!-- header -->
                <ev-header></ev-header>

                <!-- main content of the page -->
                <div class="content">
                    <router-outlet (activate)="changeOfRoutes()"></router-outlet>
                </div>
            </div>

            <app-footer
                    [backgroundColor]="settings ? settings.value.headerColor : '#d0d0ce'"
                    [textColor]="settings ? settings.value.headerTextColor : '#000000'"
                    [showVersion]="(userCanSeeVersion$ | async) === true"
                    [version]="version">
            </app-footer>

        </mat-sidenav-content>

    </mat-sidenav-container>
</main>
